function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-plus",
  "data-name": "Icon feather-plus",
  transform: "translate(7.778 -14.142) rotate(45)"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_44",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 44",
  d: "M18,7.5v16",
  transform: "translate(-2.5)",
  fill: "none",
  stroke: "#a4a3a8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_45",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 45",
  d: "M7.5,18h16",
  transform: "translate(0 -2.5)",
  fill: "none",
  stroke: "#a4a3a8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}));

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.556,
    height: 15.556,
    viewBox: "0 0 15.556 15.556",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.dbb2d461.svg";
export { ForwardRef as ReactComponent };